import { render, staticRenderFns } from "./GridAcordo.vue?vue&type=template&id=1f56836c&scoped=true&"
import script from "./GridAcordo.vue?vue&type=script&lang=js&"
export * from "./GridAcordo.vue?vue&type=script&lang=js&"
import style0 from "./GridAcordo.vue?vue&type=style&index=0&id=1f56836c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f56836c",
  null
  
)

export default component.exports